import config from '../../config';
import { PortalVerticalGameTilePropTypes } from '../../types/gameTypes';
import { fetchData } from '../utils/fetch';

export const fetchGame = async ({
  locale,
  viewer_country,
  viewer_region,
  game_code,
}: {
  locale?: string;
  viewer_country?: string;
  viewer_region?: string;
  game_code: string;
}): Promise<
  | { result: 'success'; game: PortalVerticalGameTilePropTypes }
  | { result: 'failure'; error: { status: number } }
> => {
  try {
    const res = await fetchData<{ data: PortalVerticalGameTilePropTypes }>({
      url: `${config.urls.bffBaseUrl}/game/${game_code}`,
      queryParameters: {
        locale,
        market_country: viewer_country,
        market_region: viewer_region,
      },
    });

    return {
      result: 'success',
      game: res.data,
    };
  } catch (err) {
    console.error(
      `There was a problem while fetching game. ${config.urls.bffBaseUrl}/game`
    );
    console.error(err);

    return {
      result: 'failure',
      error: err as any,
    };
  }
};
